export default __webpack_public_path__ + "static/media/fb-game-background.b797601e.png";